import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetPointHistory
 * @method apiExpirePoint
 */
export default {
    /**
     * @param {Object} params HistoryPointConfigModel - /core/Point/config/PointConfigModel.js
     */
    apiGetPointHistory: function (HistoryPointConfigModel) {
        const token = Account.getToken();
        let params = HistoryPointConfigModel.getParams();
        const url = ConfigManager.getApiUrl() + '/log/points';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map(res => res.data));
    },
    apiAllExpiring: function () {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + '/profile/me/allexpiring_points';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map(res => res.data));
    },
}
